export default "__VITE_PUBLIC_ASSET__32d55b4c__"